import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

import { Box } from '@zillow/constellation-10';

const CreditTrackingLoader = () => {
  return (
    <Box
      css={{
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 50px` falls between `1200` (48px) and `1300` (52px) on the numeric sizes scale
        minHeight: '50px',
        marginBottom: 'loose',
      }}
    >
      <div>
        <Box css={{ marginBottom: 'looser' }}>
          <LoadingHeading isLoading={true} loadingWidth="200px" level={2} textStyle="heading-sm">
            Loading...
          </LoadingHeading>
          <LoadingParagraph isLoading={true} loadingWidth="80%" css={{ marginTop: 'default' }}>
            Loading...
          </LoadingParagraph>
        </Box>
      </div>
    </Box>
  );
};

export default CreditTrackingLoader;
